import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  BadgeComponent,
  BadgeColor,
  BadgeType,
  ButtonExpand,
  ButtonVariant,
  ButtonComponent,
  Icon,
  ButtonIconLeftDirective,
  ButtonIconOnlyDirective,
  Size,
} from '@circlek-global/lds-components';

import { GtmCustomEventNameEnum } from '~components/gtm-script/gtm-custom-event-name.enum';
import { GtmCustomEventService } from '~components/gtm-script/gtm-custom-event.service';
import { TranslatePipe } from '~pipes/translate.pipe';
import { StationsService } from '~services/station.service';

@Component({
  selector: 'app-stations-filters-button',
  templateUrl: 'stations-filters-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, ButtonIconLeftDirective, TranslatePipe, ButtonIconOnlyDirective, BadgeComponent],
})
export class StationsFilterButtonComponent {
  private readonly gtmCustomEventService = inject(GtmCustomEventService);
  protected readonly ButtonVariant = ButtonVariant;
  protected readonly ButtonExpand = ButtonExpand;
  protected readonly Size = Size;
  protected readonly BadgeType = BadgeType;
  protected readonly BadgeColor = BadgeColor;
  protected readonly filtersIcon = Icon.FILTER_LINES;
  private readonly stationsService = inject(StationsService);
  protected readonly filtersCount = this.stationsService.filtersCount;

  openFiltersView(): void {
    this.gtmCustomEventService.trackEvent(GtmCustomEventNameEnum.FilterUsage);
    this.stationsService.isFiltersViewOpened.set(true);
  }
}
